import usePermissions from '@/hooks/usePermissions';
import { OrganizationNode } from '@/types/Organizations';
import { Box } from '@palmetto/palmetto-components';

import { UserPermissions } from 'types';

import { NetSuiteVendorIdSetting } from './NetSuiteVendorIdSetting';
import { PaymentsOrgSetting } from './PaymentsOrgSetting';

interface OtherSettingsProps {
  organization: OrganizationNode;
}

export const OtherSettings = ({ organization }: OtherSettingsProps) => {
  const permissions = usePermissions();

  const showBankAccountAndPaymentOrgSettingsSection = permissions.some((permission) =>
    [UserPermissions.admin, UserPermissions.orgAccountingAdmin].includes(permission),
  );
  return (
    <Box gap="md">
      {showBankAccountAndPaymentOrgSettingsSection && <PaymentsOrgSetting organization={organization} />}
      <NetSuiteVendorIdSetting />
    </Box>
  );
};
